<template>
  <v-app id="inspire">
    <Header type="return-search"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>

          <Menu/>

          <v-container class="col-10">
            <v-row>
              <v-col
                  class="page-top d-flex justify-space-between"
                  cols="12"
              >
                <div>
                  <div class="page-title">Пакет услуг 5 прыжков от 25.07.2022</div>
                  <div class="breadcrumb"><span class="breadcrumb-bold">Клиенты / Карточка клиента /</span> Пакет</div>
                </div>
              </v-col>
            </v-row>
            <v-sheet rounded="lg" class="mt-5 col-7" style="padding: 0 !important;">
              <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                    Клиент
                  </div>
                  <div class="list-item__value">
                    Иванов Иван Иванович
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                    Номенклатура
                  </div>
                  <div class="list-item__value">
                    Членство 1 месяц
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                    Услуги
                  </div>
                  <div class="list-item__value">
                    0
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                    Активация
                  </div>
                  <div class="list-item__value">
                    <v-btn class="button__activate">
                      Активировать
                    </v-btn>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                    Приобретен
                  </div>
                  <div class="list-item__value">
                    25.07.2022
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                    Договор
                  </div>
                  <div class="list-item__value">
                    №12412516
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                    Услуги
                  </div>
                  <div class="list-item__value">
                    Членство 1 месяц
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                    Гостевые посещения
                  </div>
                  <div class="list-item__value">
                    2
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-sheet>
          </v-container>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';

export default {
  name: "CardPackage",
  components: {
    Header,
    Menu,
  },
}
</script>

<style scoped>

</style>